import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getContact } from "../components/services/soar";
import Select from "./common/Select";
import RCCoTrails from "../templates/RCCoTrails";
import RCSafyInvoice from "../templates/RCSafyInvoice";

function RCInvoice(props) {
  const location = useLocation();
  const billingRules = location.state.billingRules;
  const bedDays = location.state.bedDays;
  const payors = location.state.payors;
  const passedData = location.state.data;
  const [contact, setContact] = useState({});
  const [censusPayor, setCensusPayor] = useState(
    payors.filter(
      (payor) => payor.ccx_payor["@name"] === bedDays[0].rule.payor
    )[0]
  );
  const [selectedInvoice, setSelectedInvoice] = useState("SAFY");

  useEffect(() => {
    if (!location.state.clientId) {
      return;
    }

    getContact(location.state.clientId).then((response) => {
      console.log("Contact", response[0]);
      setContact(response[0]);
    });
  }, [location.state.clientId]);

  return (
    <div>
      <Select
        label="Invoice Type"
        options={[
          { _id: "SAFY", name: "SAFY" },
          { _id: "COTRAILS", name: "CO Trails" },
        ]}
        value={selectedInvoice}
        onChange={(e) => setSelectedInvoice(e.target.value)}
      />
      <div className="">
        {selectedInvoice === "SAFY" && (
          <RCSafyInvoice
            billingRules={billingRules}
            bedDays={bedDays}
            payors={payors}
            passedData={passedData}
            clientId={location.state.clientId}
          />
        )}
        {selectedInvoice === "COTRAILS" && (
          <RCCoTrails
            billingRules={billingRules}
            bedDays={bedDays}
            payors={payors}
            passedData={passedData}
            clientId={location.state.clientId}
          />
        )}
      </div>
    </div>
  );
}

export default RCInvoice;
